import { render, staticRenderFns } from "./RequestRgEdit.vue?vue&type=template&id=4694899c&scoped=true"
import script from "./RequestRgEdit.vue?vue&type=script&lang=js"
export * from "./RequestRgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694899c",
  null
  
)

export default component.exports